import { render, staticRenderFns } from "./organisations.vue?vue&type=template&id=9558aefe&scoped=true&"
import script from "./organisations.ts?vue&type=script&lang=ts&"
export * from "./organisations.ts?vue&type=script&lang=ts&"
import style0 from "./organisations.scss?vue&type=style&index=0&id=9558aefe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9558aefe",
  null
  
)

export default component.exports